module.exports = __webpack_public_path__ + "media/images/new/icons/chevron-up-4a2c6d7a8852e0b2f9e609468e92a498.png";